import React from 'react';

import {SchemaField} from 'schemas/fields/SchemaFieldConstants';
import FormGroup from 'ui-library/bs/FormGroup';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import {SettingsLabel} from 'ui-library/SettingsField';

interface Props {
  destinationField: SchemaField;
  onSelectField: (field: SchemaField) => void;
  sourceFieldOptions: Array<SchemaField>;
  currentField: SchemaField;
}

export default function SourceFieldDropdownInput(props: Props): JSX.Element {
  const menuOptions = props.sourceFieldOptions.map((field, i) => (
    <Option
      onSelect={(value: SchemaField): void => {
        props.onSelectField(value);
      }}
      value={field}
      key={i}
    >
      {field.displayName}
    </Option>
  ));

  return (
    <FormGroup>
      <SettingsLabel label="Source field" isRequired={false} withBottomMargin={true} />
      <SelectDropdown
        displayName={props.currentField.displayName}
        menu={<Menu value={props.currentField}>{menuOptions}</Menu>}
      />
    </FormGroup>
  );
}
